import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import EngineeredSupply from "./sections/EngineeredSupply";
import MaterialCategories from "./sections/MaterialCategories";
import MarketImpact from "./sections/MarketImpact";
import Procurement from "./sections/Procurement";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <EngineeredSupply />
      <MaterialCategories />
      <MarketImpact />
      <Procurement />
      <Footer />
    </div>;
}